import React from 'react';
import PropTypes from 'prop-types';

import { withConfig } from 'Context/ConfigContext';
import MixPanelProvider from 'Context/AnalyticsContext';

const MixPanelProviderApp = ({ appConfig, children }) => (
  <MixPanelProvider projectToken={appConfig.mixpanel}>{children}</MixPanelProvider>
);

MixPanelProviderApp.propTypes = {
  appConfig: PropTypes.shape({
    mixpanel: PropTypes.shape({
      projectToken: PropTypes.string,
    }),
  }),
};

export default withConfig(MixPanelProviderApp);
